import React from 'react';
const IconStatusPlaying = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7 5V19L18 12L7 5Z" fill="#666666"/>
</svg>
);
};
export default IconStatusPlaying;